<template>
  <Modal
    :show="show"
    hide-default-actions
    width="420px"
    @close="handleClose"
  >
    <template #title>
      <span class="text-h1 text-textDarkest">Cancel this approval flow?</span>
    </template>
    <template #content>
      <p class="text-body-2 text-textDark mb-4">
        Cancelling this flow will stop the approval process for
        <strong class="text-textDarkest">{{ jobProfileTitle }}</strong>.
      </p>
      <p class="text-body-2 text-textDark mb-0">
        This action cannot be undone.
      </p>
      <div class="d-flex justify-end mt-4">
        <DpplNewButton
          class="cancel-confirm-btn"
          height="40"
          :disabled="loading"
          :loading="loading"
          @click="handleCancel"
        >
          {{ buttonText }}
        </DpplNewButton>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  jobProfileTitle: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'cancel']);

const buttonText = computed(() => {
  if (props.loading) {
    return 'Cancelling Approval Flow...';
  }

  return 'Cancel Approval Flow';
});

const handleClose = () => {
  emit('close');
};

const handleCancel = () => {
  emit('cancel');
};
</script>

<style scoped lang="less">
:deep(.content) {
  margin-top: 0 !important;
}

.cancel-confirm-btn.v-btn {
  background: @red-700;
  color: @white;
}

:deep(.modal-content-wrapper.pr-6.pl-6) {
  padding: 0 !important;
}
</style>
